import { useQuery } from '@tanstack/react-query'

import { request } from 'Lib/axios'
import { QueryConfig, ExtractFnReturnType } from 'Lib/react-query'

import { DomainsInvalidRateData, dashboardSummaryParams } from './types'
import { useUserStore } from 'Stores/userStoreModuleFed'

export type QueryFnType = typeof getDomainsInvalidRate

export const getDomainsInvalidRate = async (
  accountId: number,
  userId: number,
  params?: Omit<dashboardSummaryParams, 'domains'>
) => {
  return request<{ data: DomainsInvalidRateData[] }>({
    method: 'POST',
    url: `/users/${userId}/accounts/${accountId}/dashboard/get-domains-invalid-rate`,
    data: params,
  })
}

export const useGetDomainsInvalidRate = (
  params?: dashboardSummaryParams,
  { config }: { config?: QueryConfig<QueryFnType> } = {}
) => {
  const { accountId, userId } = useUserStore.getState()
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [
      'getDomainsInvalidRateGW',
      [accountId, params?.startDate, params?.endDate, params?.campaigns, params?.platforms],
    ],
    queryFn: () => getDomainsInvalidRate(accountId, userId, params),
    enabled: true,
    ...config,
  })

  const data = query.data && query.data instanceof Error ? undefined : query.data?.data

  return { ...query, data }
}
